import { gql } from '@apollo/client';
import { NotificationFragment } from './fragment';

export const GET_NOTIFICATIONS = gql`
  query notificationByViewerId($viewerID: ID!,$platform: EPlatform!,$filter: NotificationFilter) {
    results: notificationByViewerId(viewerID: $viewerID,platform: $platform,filter:$filter) {
      code
      error
      message
      data {
        ...NotificationFragment
      }
      countTotal
      totalPages
      currentPage
    }
  }
  ${NotificationFragment}
`;

export const COUNT_NOTIFICATION_BADGE = gql`
  query countNotificationsByPlatform($viewerId: ID!, $viewerPlatform: ID!, $platform: EPlatform!) {
    countNotificationsByPlatform(viewerId: $viewerId, viewerPlatform: $viewerPlatform, platform: $platform) {
      error
      code
      message
      data
    }
  }
`;
